import styled from 'styled-components';

export default styled.span`
    padding: 3px 6px;
    margin: 0px 2px;
    border-radius: 7px;
    border: 1px solid #d3d4d6;
    background: #eef2fb;
    font-family: 'Ubuntu Mono', monospace;
`;
